import React, { useEffect } from "react";
import { motion, useMotionValue, animate } from "framer-motion";

const AnimateSpringUp = ({
  children,
  initialYOffset,
  finalYOffset,
  initialZIndex,
  finalZIndex,
  duration,
  bounce,
  repeatDelay,
  style,
  ...props
}) => {
  const zIndex = useMotionValue(0);

  useEffect(() => {
    animate(initialZIndex || 0, finalZIndex || 1, {
      duration: duration || 0.8,
      repeatDelay: repeatDelay || 5,
      repeat: Infinity,
      repeatType: "reverse",
      onUpdate: (latest) => zIndex.set(Math.round(latest)),
    });
  });

  return (
    <motion.div
      initial={{
        y: initialYOffset || 40,
      }}
      animate={{
        y: finalYOffset || 0,
      }}
      transition={{
        type: "spring",
        bounce: bounce || 0.5,
        duration: duration || 0.8,
        repeatDelay: repeatDelay || 5,
        repeat: Infinity,
        repeatType: "reverse",
      }}
      style={{
        ...style,
        zIndex: zIndex,
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default AnimateSpringUp;
